import React from "react";
import Spinner from "../../components/presentationals/Spinner";
import { timeStampFormat } from "../../utils/common";

const CustomTable = ({
  data,
  headers,
  tableData,
  timestamp,
  csvHandler,
  csvLoading,
}) => {
  let totalCount = tableData?.data?.content?.reduce(
      (acc, curr) => parseInt(acc) + parseInt(curr?.count),
      0
    ),
    totalObv = tableData?.data?.content?.reduce(
      (acc, curr) => parseInt(acc) + parseInt(curr?.obv),
      0
    );
  return (
    <div
      className="whitebox wow fadeInUp"
      data-wow-delay=".6s"
      data-wow-duration="0.7s"
    >
      <div className="subtitlebox">
        <div className="subtitleboxChild">{data.tileName}</div>
        {data?.isCsvActive === "Y" && (
          <div>
            {csvLoading ? (
              <Spinner showAlert={false} />
            ) : (
              <span className="downloadarrow">
                <button
                  value="Export report to Excel"
                  type="button"
                  id="ExportReporttoExcel"
                  className="btn btn-link btn-sm m-0 p-0"
                  onClick={() => csvHandler(data.tileName)}
                >
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/icons/download-arrow.svg"
                    }
                    alt="download"
                  />
                </button>
              </span>
            )}
          </div>
        )}
      </div>
      <div className="row">
        {tableData.loading ? (
          <Spinner />
        ) : (
          <div className="datatable earnings-table" data-cy="earnings-table">
            <table className="table table-striped">
              <thead>
                <tr role="row">
                  {headers.map((row, index) => {
                    return (
                      <th
                        colSpan="1"
                        style={{ fontWeight: "bold" }}
                        key={index}
                      >
                        {row}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {tableData?.data?.content?.length ? (
                  <>
                    {tableData.data.content.map((obj, index) => {
                      return (
                        <tr key={index}>
                          <td colSpan="1">{obj.kpi}</td>
                          {typeof obj?.count === "number" && (
                            <td>{obj.count ?? 0}</td>
                          )}
                          {obj?.obv && <td>{obj.obv ?? 0}</td>}
                        </tr>
                      );
                    })}
                    {!isNaN(totalObv) && (
                      <tr>
                        <td colSpan={1} style={{ fontWeight: "bold" }}>
                          Total
                        </td>
                        {!isNaN(totalCount) && (
                          <td colSpan={1} style={{ fontWeight: "bold" }}>
                            {totalCount}
                          </td>
                        )}
                        {!isNaN(totalObv) && (
                          <td colSpan={1} style={{ fontWeight: "bold" }}>
                            {totalObv}
                          </td>
                        )}
                      </tr>
                    )}
                  </>
                ) : (
                  //if the response is empty, show no data available
                  <tr>
                    <td colSpan={3} className="text-center">
                      no data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {timestamp ? (
        <div
          className="card-timestamp border-top mt-2"
          data-cy="card-timestamp"
        >
          <i className="fa fa-history mr-2 mt-2 mb-0"></i>Updated on {timestamp}
        </div>
      ) : null}
    </div>
  );
};

export default CustomTable;
